/**
 * Scroll To Top Button — MAMe Distribuzioni
 * Posizionato al centro-basso dello schermo (non interferisce con la chat a destra)
 *
 * Istruzioni:
 * 1. Copia questo file nella cartella  assets/  del tema tramite Shopify CLI o editor VS Code
 * 2. Aggiungi in  layout/theme.liquid  prima di </body>:
 *    <script src="{{ 'scroll-to-top.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  // ── Configurazione ──────────────────────────────────────────────────────────
  var CONFIG = {
    showAfterPx: 400,      // mostra il bottone dopo N pixel di scroll
    scrollDuration: 500,   // durata animazione scroll (ms)
    bottomOffset: '28px',  // distanza dal fondo
    size: '48px',          // dimensione del bottone
  };

  // ── Stili ───────────────────────────────────────────────────────────────────
  var STYLES = [
    '#mame-scroll-top {',
    '  position: fixed;',
    '  bottom: ' + CONFIG.bottomOffset + ';',
    '  left: 50%;',
    '  transform: translateX(-50%) translateY(16px);',
    '  z-index: 9999;',
    '  width: ' + CONFIG.size + ';',
    '  height: ' + CONFIG.size + ';',
    '  border-radius: var(--radius-button, 6px);',
    '  background: var(--color-accent, #111111);',
    '  color: var(--auto-text-color-accent, #ffffff);',
    '  border: none;',
    '  cursor: pointer;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  padding: 0;',
    '  box-shadow: 0 4px 16px rgba(0,0,0,0.20);',
    '  opacity: 0;',
    '  visibility: hidden;',
    '  transition:',
    '    opacity 300ms ease,',
    '    visibility 300ms ease,',
    '    transform 300ms cubic-bezier(0.68, -0.13, 0.3, 1.26),',
    '    background 200ms ease,',
    '    box-shadow 200ms ease;',
    '  -webkit-tap-highlight-color: transparent;',
    '}',

    /* stato visibile — translateX(-50%) rimane sempre per centrare */
    '#mame-scroll-top.is-visible {',
    '  opacity: 1;',
    '  visibility: visible;',
    '  transform: translateX(-50%) translateY(0);',
    '}',

    /* hover solo desktop */
    '@media (min-width: 1025px) {',
    '  #mame-scroll-top:hover {',
    '    background: var(--color-base, #000000);',
    '    box-shadow: 0 8px 28px rgba(0,0,0,0.28);',
    '    transform: translateX(-50%) translateY(-4px);',
    '  }',
    '}',

    /* touch feedback mobile */
    '@media (max-width: 1024px) {',
    '  #mame-scroll-top:active {',
    '    transform: translateX(-50%) scale(0.92);',
    '  }',
    '  #mame-scroll-top {',
    '    bottom: calc(' + CONFIG.bottomOffset + ' + env(safe-area-inset-bottom, 0px));',
    '  }',
    '}',

    /* su mobile piccolo: sale sopra la barra del browser */
    '@media (max-width: 576px) {',
    '  #mame-scroll-top {',
    '    bottom: calc(76px + env(safe-area-inset-bottom, 0px));',
    '  }',
    '}',

    '#mame-scroll-top svg {',
    '  pointer-events: none;',
    '  display: block;',
    '  fill: currentColor;',
    '}',
  ].join('\n');

  // ── Icona SVG (freccia su sottile) ──────────────────────────────────────────
  var ICON_SVG = [
    '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"',
    '     aria-hidden="true" focusable="false">',
    '  <path fill-rule="evenodd" clip-rule="evenodd"',
    '    d="M10 3.293L3.354 9.939 2.646 9.232 10 1.878l7.354 7.354-.708.707L10 3.293z"/>',
    '  <path fill-rule="evenodd" clip-rule="evenodd"',
    '    d="M10 18.5V3h1v15.5h-1z"/>',
    '</svg>',
  ].join('');

  // ── Init ────────────────────────────────────────────────────────────────────
  function init() {
    if (document.getElementById('mame-scroll-top')) return; // evita duplicati

    // Inietta CSS
    var styleEl = document.createElement('style');
    styleEl.id = 'mame-scroll-top-styles';
    styleEl.textContent = STYLES;
    document.head.appendChild(styleEl);

    // Crea bottone
    var btn = document.createElement('button');
    btn.id = 'mame-scroll-top';
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-label', 'Torna in cima alla pagina');
    btn.innerHTML = ICON_SVG;
    document.body.appendChild(btn);

    // ── Mostra/nascondi al scroll ──────────────────────────────────────────────
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        btn.classList.toggle('is-visible', scrollY > CONFIG.showAfterPx);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // ── Click: scroll animato ──────────────────────────────────────────────────
    btn.addEventListener('click', function () { scrollToTop(CONFIG.scrollDuration); });

    // Accessibilità tastiera
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToTop(CONFIG.scrollDuration);
      }
    });
  }

  // ── Scroll con easing quadratico ────────────────────────────────────────────
  function scrollToTop(duration) {
    var start = window.pageYOffset || document.documentElement.scrollTop;
    var startTime = null;
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function step(now) {
      if (!startTime) startTime = now;
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start * (1 - ease(progress)));
      if (elapsed < duration) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // ── Avvio sicuro ─────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();